import { Component, OnInit } from '@angular/core';
import { Project, ProjectPhase } from 'src/app/interfaces/investmentcontrolling/inco-project';
import { DefaultValuesService } from 'src/app/services/defaultvalues.service';
import { InvestmentControllingService } from 'src/app/services/investment-controlling.service';

@Component({
  selector: 'app-inco-focus',
  templateUrl: './inco-focus.component.html',
  styleUrls: ['./inco-focus.component.less'],
  standalone: false
})
export class IncoFocusComponent implements OnInit {


  displayedColumns: string[] = ['projectId', 'projectTitle', 'projectResponsible', 'maintenance', 'expansion', 'focus', 'phase'];
  projectsData: Project[] = [];
  projectPhases: ProjectPhase[] = [];
  subscriptionManagementId: any;
  title: string;

  constructor(private incoService: InvestmentControllingService,
    private readonly defaults: DefaultValuesService,
  ) { 
    this.title = `INCO: Focus projects`;
  }

  ngOnInit(): void {
    // this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { this.loadData() });
    if (this.defaults.managementids.length !== 0) {
      this.loadData();
    }
    this.getProjectPhase();
  }


  loadData() {
    this.incoService.loadFocusProjects(this, function (tthis: IncoFocusComponent, result: Project[]) {
      setTimeout(() => {
        tthis.projectsData = result;
      }, 50)
    }
      , null)
  }


  getProjectPhase() {
    this.incoService.getProjectPhase(
      this,
      function (tthis: IncoFocusComponent, result: ProjectPhase[]) {
        tthis.projectPhases = result;
      },
      null
    );
  }


  getBooleanDisplay(value: boolean): string {
    return value ? 'YES' : 'NO';
  }

  getPhaseLabel(phaseId: number | undefined): string {
    const phase = this.projectPhases.find(p => p.id === phaseId);
    return phase ? `${phaseId} - ${phase.phaseName}` : `${phaseId}`;
  }
}
